import { addDoc, collection } from 'firebase/firestore';
import { db } from '../config/firebase';
import type { Message, Notification } from '../types/notifications';

export async function sendHeaderMessage(userId: string, message: Partial<Message>) {
  try {
    const messageData = {
      userId,
      sender: message.sender,
      content: message.content,
      timestamp: new Date(),
      read: false
    };

    await addDoc(collection(db, 'headerMessages'), messageData);
    return true;
  } catch (error) {
    console.error('Error sending header message:', error);
    return false;
  }
}

export async function sendNotification(userId: string, notification: Partial<Notification>) {
  try {
    const notificationData = {
      userId,
      title: notification.title,
      content: notification.content,
      type: notification.type || 'info',
      timestamp: new Date(),
      read: false,
      link: notification.link
    };

    await addDoc(collection(db, 'notifications'), notificationData);
    return true;
  } catch (error) {
    console.error('Error sending notification:', error);
    return false;
  }
}

// Exemplo de uso:
/*
// Enviar uma mensagem no header
await sendHeaderMessage('user123', {
  sender: 'Sistema',
  content: 'Nova mensagem de teste'
});

// Enviar uma notificação
await sendNotification('user123', {
  title: 'Sucesso!',
  content: 'Operação realizada com sucesso',
  type: 'success',
  link: '/dashboard'
});
*/
